import { render, staticRenderFns } from "./AdminTest.vue?vue&type=template&id=9858be22&scoped=true&"
import script from "./AdminTest.vue?vue&type=script&lang=js&"
export * from "./AdminTest.vue?vue&type=script&lang=js&"
import style0 from "./AdminTest.vue?vue&type=style&index=0&id=9858be22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9858be22",
  null
  
)

export default component.exports